export default __webpack_public_path__ + "static/media/feedback_black_24dp.f82afc7b.svg";